import React from 'react'
import { makeStyles } from '@material-ui/styles'
import DazzedParagraph14 from 'components/common/text/DazzedParagraph14'
import { formatApptDate, formatApptTimeRange } from './greyfinchFormat'

// Primary dark navy (upcoming rows) and a lighter grey for de-emphasised past rows.
const DARK_COLOR = '#001335'
const PAST_COLOR = '#A6ACB9'
const DIVIDER_COLOR = '#E6E6E6'

// type + date truncate with an ellipsis (full value on hover via title) instead of wrapping, so a long
// appointment type like "Comprehensive Records + Photos" can't push the row to two lines and misalign the
// column dividers.
const ellipsis = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
}

const useStyles = makeStyles(() => ({
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: 12
  },
  type: {
    flex: '1 1 0',
    minWidth: 0,
    ...ellipsis
  },
  date: {
    flex: '1.3 1 0',
    minWidth: 0,
    ...ellipsis
  },
  time: {
    flex: '1 1 0',
    whiteSpace: 'nowrap'
  },
  // thin vertical rule between the type | date | time columns (matches the design)
  divider: {
    flex: '0 0 auto',
    width: 1,
    height: 16,
    background: DIVIDER_COLOR
  }
}))

const AppointmentRow = ({ appointment, muted = false }) => {
  const classes = useStyles()
  const color = muted ? PAST_COLOR : DARK_COLOR
  // Optional-chain every field read: a null element in the array must not throw.
  const type = appointment?.type || ''
  const date = formatApptDate(appointment?.date)
  const timeRange = formatApptTimeRange(appointment?.time, appointment?.endTime)

  return (
    <div className={classes.row}>
      <DazzedParagraph14 strong color={color} textAlign="left" className={classes.type} title={type}>
        {type}
      </DazzedParagraph14>
      <div className={classes.divider} />
      <DazzedParagraph14 strong color={color} textAlign="center" className={classes.date} title={date}>
        {date}
      </DazzedParagraph14>
      <div className={classes.divider} />
      <DazzedParagraph14 strong color={color} textAlign="right" className={classes.time}>
        {timeRange}
      </DazzedParagraph14>
    </div>
  )
}

export default AppointmentRow
